import { AlertProps } from "@zapier/design-system";

export type StatusRollupType = Record<string, number>;

export type MassActionType = "delete" | "replay";

export type OnMassAction = (
  type: MassActionType,
  variables: any,
  onComplete: (refetch: boolean) => void
) => void;

type MassActionLink = {
  href: string;
  text: string;
};

export type MassActionMessageBody = {
  link?: MassActionLink;
  message: string;
};

export type MassActionMessage = {
  body?: MassActionMessageBody[];
  id?: string;
  link?: MassActionLink;
  messageType?: AlertProps["status"];
  text?: string | string[];
  title?: string;
};

export enum MassActionFailureStatus {
  access_blacklisted_app = "access_blacklisted_app",
  deleted_zap = "deleted_zap",
  diverged_zap = "diverged_zap",
  expired_task = "expired_task",
  outstanding_task = "outstanding_task",
  paused_zap = "paused_zap",
  plan_limit = "plan_limit",
  playing_task = "playing_task",
  stale_auth = "stale_auth",
  successful_task = "successful_task",
  unsuccessful_task = "unsuccessful_task",
  incorrect_access_level = "incorrect_access_level",
}
